import React, { Component, PropTypes } from 'react';
import { mixin, RefluxMixin } from 'Util';
import AuthActions from 'actions/Auth';
import { Paper, Styles } from 'material-ui';
import AuthStore from 'stores/Auth';
import AppPage from 'components/AppPage';
import EventManager from 'services/EventManager';
import Message from 'services/Message';
import MediaQuery from 'services/MediaQuery';
import CountdownTimer from 'components/CountdownTimer';
import { history } from 'helpers';

let { Spacing } = Styles;

export default class Login extends mixin(RefluxMixin, Component) {
  static contextTypes = {
    muiTheme: PropTypes.object,
    getIntlMessage: PropTypes.func,
    media: PropTypes.string
  };

  listenToStores() {
    this.listenToStore(AuthStore);
  }

  redirect() {
    history.replace(`/dashboard`);
  }

  componentDidMount() {
    if (this.state.loggedIn) {
      history.replace(`/logged-in`);
    }
  }

  onError(errorMessage) {
    Message.info(errorMessage);
  }

  handleSubmit(email, password) {
    AuthActions.login(email, password);
  }

  render() {
    const marginCss =
      this.context.media === 'phone' ? 'auto' : '100px auto auto';

    return (
      <AppPage
        style={{
          backgroundColor: 'transparent',
          backgroundImage: 'url(' + require('library.jpg') + ')',
          backgroundPosition: 'top left',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          marginTop: -Spacing.desktopKeylineIncrement,
          paddingTop: Spacing.desktopKeylineIncrement,
          boxSizing: 'initial'
        }}
      >
        <Paper
          zDepth={2}
          style={{
            backgroundColor: this.context.muiTheme.rawTheme.palette.cardColor,
            width: Spacing.desktopKeylineIncrement * 5 - 20,
            margin: marginCss,
            padding: Spacing.desktopGutterMini
          }}
        >
          <div style={{ textAlign: 'center' }}>
            {this.context.getIntlMessage('login.redirectIncoming')}
            <br />
            <CountdownTimer
              seconds={5}
              color="#777"
              alpha={0.3}
              size={128}
              onComplete={::this.redirect}
            />
          </div>
        </Paper>
      </AppPage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/LoggedIn.js